<div class="layout" [class.no-clickable]="lockUserInteraction">
  <div class="layout__page" [attr.inert]="isSummaryExpanded ? '' : null">
    <qb-ita-header
      logoImage="/assets/img/logos/verti.svg"
      [isLogoClickable]="true"
      [headerText]="'HEADER.DEFAULT' | translate"
      [promotionalImage]="headerPromotionalImage"
      [promotionalUrl]="headerPromotionalUrl"
      [headerPromotionalShowInd]="headerPromotionalShowInd"
      [vertiUrl]="VERTI_URL"
      [showPhoneNumber]="true"
      [phoneIcon]="'verti-phone-24'"
      [phoneNumber]="phoneNumber"
      (phoneNumberClick)="onHeaderPhoneNumberClick()"
    ></qb-ita-header>
    <div
      class="layout__scroll-container"
      [ngClass]="{ button__mobile: !hideNextButtonMobile && !hideNextButton }"
      tabindex="-1"
      >
      <div class="layout__container">
        <div
          class="layout__content"
          [ngClass]="{ 'layout__content--center': contentCentered, 'layout__content--padding': contentPadding }"
          >
          <div class="form-wrapper">
            <div role="navigation">
              @if (showSteps && steps?.length && currentStep) {
                <qb-ita-step
                  class="layout__steps--desktop"
                  [steps]="steps"
                  [currentStep]="currentStep"
                  [percent]="percent"
                  (stepClicked)="stepClicked.emit($event)"
                ></qb-ita-step>
                <div class="layout__steps--container">
                  <ng-container *ngTemplateOutlet="backButton; context: { hideTextMobile: true }"></ng-container>
                  <qb-ita-circle-progress-bar
                    class="layout__steps--mobile"
                    [steps]="steps"
                    [currentStep]="currentStep"
                    [percent]="percent"
                  ></qb-ita-circle-progress-bar>
                </div>
              }
              <!-- If there are no steps, back button should show the text label -->
              @if (!(showSteps && steps?.length && currentStep)) {
                <ng-container *ngTemplateOutlet="backButton; context: { hideTextMobile: false }"></ng-container>
              }
            </div>

            <main role="main">
              <div
                class="layout__form"
                [ngClass]="{
                  footer__bottom: !hideNextButtonMobile && !onDesktop,
                  'layout__form--quick-quote':
                    stepName === getLastLevelPath(RoutePaths.QUICK_QUOTE.QUICK_QUOTE.INSURANCE_HOLDER_DATA.route)
                }"
                >
                @if (stepPageTitle || stepPageDescription) {
                  <div class="layout__header">
                    @if (stepPageIcon) {
                      <ion-icon class="{{ stepPageIcon }} layout__icon color--secondary3"></ion-icon>
                    }
                    @if (stepPageTitle) {
                      <h2 class="layout__title text--24 text--bold">{{ stepPageTitle }}</h2>
                    }
                    @if (stepPageDescription) {
                      <h3 class="layout__subtitle text--16">
                        <span [innerHtml]="stepPageDescription | qbItaSafeHtml"></span>
                      </h3>
                    }
                  </div>
                }

                <ion-grid class="full-width">
                  <ion-row>
                    <ion-col
                      size="12"
                      class="layout__main-content"
                      [attr.size-md]="showSummaryLite && !pageLoading ? 6 : 12"
                      >
                      <ng-content></ng-content>
                    </ion-col>

                    @if (showSummaryLite && !pageLoading && (summaryLiteData$ | async)) {
                      <ion-col
                        size-md="6"
                        class="layout__summary"
                        >
                        <qb-ita-quotation-summary-lite
                          [summaryData]="summaryLiteData$ | async"
                          [showCoverages]="showSummaryLiteCoverages"
                          [showSummaryPDF]="showSummaryLitePDF"
                          (downloadPDFClick)="summaryLitePDFClick.emit()"
                          [pdfIcon]="'verti-pdf-16'"
                          [mobileHeaderIcon]="'verti-car-side-16'"
                        ></qb-ita-quotation-summary-lite>
                      </ion-col>
                    }
                  </ion-row>
                </ion-grid>

                @if (!hideNextButton) {
                  <div>
                    @if (!hideNextButton) {
                      <qb-ita-button
                        class="layout__next-button"
                        [label]="nextBtnTitle || ('CONTINUE_BUTTON.TITLE' | translate)"
                        (btnClick)="nextBtnClick.emit()"
                        [buttonPosition]="nextBtnPosition || 'center'"
                        [disabled]="nextBtnDisabled"
                        [hasMinWidth]="true"
                        [showSpinner]="nextButtonShowSpinner"
                      ></qb-ita-button>
                    }
                  </div>
                }

                @if (!hideSecondaryButton) {
                  <div>
                    @if (!hideSecondaryButton) {
                      <qb-ita-button
                        class="layout__next-button"
                        color="secondary"
                        [label]="secondaryBtnTitle || ('BACK_BUTTON.TITLE' | translate)"
                        (btnClick)="secondaryBtnClick.emit()"
                        buttonPosition="center"
                        [disabled]="secondaryBtnDisabled"
                        [showSpinner]="secondaryButtonShowSpinner"
                      ></qb-ita-button>
                    }
                  </div>
                }
              </div>
            </main>
          </div>
        </div>
        <div>
          @if (showSeoFooter) {
            <div class="footer__seo-container">
              <qb-ita-seo-footer
              [seoTitle]="
                flowName === Flow.NEW_QUOTATION
                  ? ('SEO_FOOTER.FULL_QUOTE.TITLE' | translate)
                  : ('SEO_FOOTER.QUICK_QUOTE.TITLE' | translate)
              "
              [seoContent]="
                flowName === Flow.NEW_QUOTATION
                  ? ('SEO_FOOTER.FULL_QUOTE.CONTENT' | translate)
                  : ('SEO_FOOTER.QUICK_QUOTE.CONTENT' | translate)
              "
              ></qb-ita-seo-footer>
            </div>
          }
          <div class="footer__container">
            <qb-ita-footer [footerLinks]="footerLinks"></qb-ita-footer>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (showSummaryLite && !pageLoading && (summaryLiteData$ | async)) {
    <div
      class="summary-lite--mobile"
      [attr.aria-label]="'SUMMARY_LITE.A11Y.DIALOG' | translate"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      >
      <qb-ita-quotation-summary-lite
        [summaryData]="summaryLiteData$ | async"
        [showCoverages]="showSummaryLiteCoverages"
        [showSummaryPDF]="showSummaryLitePDF"
        (isSummaryExpanded)="isSummaryExpanded = $event"
        (downloadPDFClick)="summaryLitePDFClick.emit()"
        [pdfIcon]="'verti-pdf-16'"
        [mobileHeaderIcon]="'verti-car-side-16'"
      ></qb-ita-quotation-summary-lite>
    </div>
  }
</div>

<ng-template #backButton let-hideTextMobile="hideTextMobile">
  @if (!hideBackButton) {
    <qb-ita-back-button
      class="layout__back-button"
      [title]="backBtnTitle || ('BACK_BUTTON.TITLE' | translate)"
      (back)="backBtnClick.emit()"
      [hideTextMobile]="hideTextMobile"
      arrowLeftIcon="verti-arrow-simple-left-24"
    ></qb-ita-back-button>
  }
</ng-template>
